import { gql } from "@apollo/client";


export const GET_HSC_CLOSINGS_QUERY = gql`
query GetHscClosing($arcimedesRowId: ID!) {
  getHscClosing(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    property_id
    name
    city
    state
    sold_price
    close_cap_rate
    loan_amount
    ltv
    interest_rate
    amortization
    term
    cash_on_cash
    referred_by
    link
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`

export const  GET_REFERRAL_CLOSINGS_QUERY = gql`
query GetReferralClosing($arcimedesRowId: ID!) {
  getReferralClosing(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    property_id
    name
    city
    state
    referral_fee
    close_of_escrow
    agent_name
    link
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`


export const  GET_OFF_MARKET_SELLERS_QUERY = gql`
query GetOffMarketSeller($arcimedesRowId: ID!) {
  getOffMarketSeller(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    property_id
    building_type
    name
    address
    city
    state
    price
    agent_last_name
    agent_first_name
    cap_rate
    link
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`


export const JUST_LISTED_JUST_CLOSED_PROPERTY_QUERY = gql`
query justListedJustClosedProperty
($propertyId: ID) {
  justListedJustClosedProperty(property_id: $propertyId)
}
`

export const NEGOTIATION_UNDER_CONTRACT_PROPERTY_QUERY = gql`
query negotiationUnderContractProperty($propertyId: ID) {
  negotiationUnderContractProperty(property_id: $propertyId)
}
`

export const PROPERTY_DATA_DEFAULT_EMAIL_QUERY = gql`
query propertyDataDefaultEma($propertyId: ID) {
  propertyDataDefaultEmail(property_id: $propertyId)
}
`